import { render, staticRenderFns } from "./chateau-kirwan.vue?vue&type=template&id=4c96e746&scoped=true"
import script from "./chateau-kirwan.vue?vue&type=script&lang=js"
export * from "./chateau-kirwan.vue?vue&type=script&lang=js"
import style0 from "./chateau-kirwan.vue?vue&type=style&index=0&id=4c96e746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96e746",
  null
  
)

export default component.exports